import React from 'react'

export const Tab = ({ children, id }) => <div id={id}>{children}</div>

Tab.displayName = 'Tab'

export default Tab
